import { FunctionComponent } from 'react'
import { Modal } from '@conexasaude/hero'
import { Success as SuccessIcon } from '@conexasaude/icons'

import { useStyles } from './styles'

const BANK_DATA_FORM_URL = 'https://forms.office.com/r/ZxW8hB0B7c'

type SuccessModalProps = {
  isOpen: boolean
  onClose: () => void
}

const SuccessModal: FunctionComponent<SuccessModalProps> = ({
  isOpen,
  onClose,
}) => {
  const styles = useStyles()

  return (
    <Modal
      open={isOpen}
      title="Sucesso!"
      onClose={onClose}
      primaryAction={() => window.open(BANK_DATA_FORM_URL)}
      primaryActionLabel="Preencher dados bancários"
      secondaryAction={onClose}
      secondaryActionProps={{
        variant: 'outlined',
        styles: {
          root: styles.declineButton,
        },
      }}
      secondaryActionLabel="Agora não"
      styles={{
        backdrop: styles.backdrop,
        modal: styles.modal,
      }}
    >
      <div css={styles.modalContent}>
        <SuccessIcon color="#2ED47A" size="large" />
        <strong>Cadastro enviado com sucesso!</strong>
        <p>
          Para pagamento dos seus plantões, por favor, preencha seus dados
          bancários.
        </p>
      </div>
    </Modal>
  )
}

export default SuccessModal
